import { Business_Context, Gstin } from '@app/types/global.type';
// import { environment } from '@env/environment';

export function getGstinList(data: Business_Context, list: Gstin[]) {
  let gstinList: Gstin[] = [];
  if (list.length > 0) {
    gstinList = [...list];
  } else {
    return gstinList;
  }

  if (data.companyid || data.gstinNo !== '') {
    gstinList = gstinList.map((obj) => ({
      ...obj,
      checked:
        data.companyid === String(obj.companyId) || data.gstinNo === obj.value
          ? true
          : false,
    }));
  }
  const isAnyGstinSelected = gstinList.findIndex((obj) => {
    return obj.checked;
  });

  if (isAnyGstinSelected < 0) {
    gstinList[0].checked = true;
  }

  return gstinList;
}
